export default __webpack_public_path__ + "static/media/4.f2f5f883.webp";